module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesLuxury@2x.5ba232c.webp";